// apolloClient.js
import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import axios from "axios";
import moment from "moment";
import { sha512 } from "js-sha512";
import { encoded } from "./cryptoUtils";

// Set Base URL dynamically
const BaseUrl = (!process.env.NODE_ENV || process.env.NODE_ENV === "development") 
  ? "http://localhost:6010/" 
  //? "http://192.168.241.1:5010/"
  //? "https://www.api.yatrascookingcave.com/"
  : "https://www.api.yatrascookingcave.com/";

// Axios instance
export const apiClient = axios.create({
  baseURL: BaseUrl,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
  },
});

// Add the token dynamically before each request
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("Authorization1");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Apollo GraphQL Client
export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: `${BaseUrl}graphql`,
  }),
});

// Generate Request Token
const getRequestToken = () => {
  const now = moment(new Date()).format("MMM DD YYYY hh");
  return sha512(now + "vimkes");
};

let payload = { 
  Authorization: localStorage.getItem("Authorization"),
  menu_id: localStorage.getItem("menu_id"),
  branch_id: localStorage.getItem("branch_id_1"),
  company_id: localStorage.getItem("company_id_1"),
};

// Generate Headers
export let getHeaders = () => ({
  Authorization: localStorage.getItem("Authorization"),
  customData: encoded(JSON.stringify(payload)),
});

export let getHeaders1 = () => ({
  Authorization: getRequestToken(),
  customData: encoded(JSON.stringify({Authorization: getRequestToken()})),
});
